import {testChildString} from "../../../../tests/test-data";

export const NModalDefProps = {
  children: testChildString,
  modalTitle: 'Test Modal Title',
  modalCancelBtnText: 'Test Cancel',
  modalActionBtnText: 'Test Action',
  hideInUiKit: true,
  forbidBodyHiddenOverflow: true
};